import ReducerUtils from "../../utils/ReducerUtils"
import Actions      from "../../model/constant/actions"

export const IsFetching = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVE_ACCOUNTS_FOR_TOKEN] : ()=>false,
  [Actions.RETRIEVING_ACCOUNTS_FOR_TOKEN] : ()=>true,
})
